/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'

import {
  deletePointOfContact,
} from '../../../../assets/ts/data/points-of-contact'
import { formatPhoneNumber } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import usePointsOfContacts from '../../../../hooks/use-points-of-contact'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import NO_RESULTS from '../../../../utils/constants/no-results'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import AddEditView from './add-edit-view'

const SettingsPOC = ({
  assignedComponentOptions,
  initialMajcomOptions,
  initialSectionOptions,
  initialSquadronOptions,
  roleContext,
  visibleSquadrons
}: any) => {
  const { components, majcoms, sections } = useContext(MetadataContext)


  const [sectionOptions, setSectionOptions] = useState<any[]>(initialMajcomOptions)
  const [majcomOptions, setMajcomOptions] = useState<any[]>(initialSectionOptions)
  const [squadronOptions, setSquadronOptions] = useState<any[]>(initialSquadronOptions)

  const { fetchPointsOfContact, pointsOfContact } = usePointsOfContacts({
    isArchivedFilter: null
  })

  const [filteredPointsOfContact, setFilteredPointsOfContact] = useState<any[]>(
    []
  )

  const [inputValues, setInputValues] = useState({
    assignedComponentCode: ALL_SELECT_VALUE,
    majcomCode: ALL_SELECT_VALUE,
    sectionCode: ALL_SELECT_VALUE,
    squadron: ALL_SELECT_VALUE_STRING
  })

  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false
  })
  const [clickedItem, setClickedItem] = useState(false)
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const onAssignComponentChange = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === e.value || e.value === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = [
      ...majOptions.filter((majcom) => majcom.squadron).map((majcom) => ({
        label: majcom.squadron,
        value: majcom.squadron
      }))
    ]

    let majcomValue: any = ALL_SELECT_OPTION.value
    let sectionValue: any = ALL_SELECT_OPTION.value
    let squadronValue: any = ALL_SELECT_OPTION_STRING.value

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    } else if (majOptions.length === 1) {
      majcomValue = majOptions[0].value
    }

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    } else if (squadOptions.length === 1) {
      squadronValue = squadOptions[0].value
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: e.value,
      majcomCode: majcomValue,
      sectionCode: sectionValue,
      squadron: squadronValue,
    }))
  }
  const onMajcomChange = (e: any) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = [
      ...majcomOptions.filter((majcom) => majcom.squadron).map((majcom) => ({
        label: majcom.squadron,
        value: majcom.squadron
      }))
    ]

    let sectionValue: any = ALL_SELECT_OPTION.value
    let squadronValue: any = ALL_SELECT_OPTION_STRING.value

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    } else if (sectOptions.length === 1) {
      squadronValue = squadOptions[0].value
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    setInputValues((prevState) => ({
      ...prevState,
      majcomCode: e.value,
      sectionCode: sectionValue,
      squadron: squadronValue
    }))
  }
  function onSquadronChange(e: { label: string; value: number }) {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let sectionValue: any = ALL_SELECT_OPTION.value

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    setInputValues((prevState) => ({
      ...prevState,
      sectionCode: sectionValue,
      squadron: e.value,
    }))
  }

  const onSectionChange = (e: { label: string; value: number }) => {
    setInputValues((prevState) => ({
      ...prevState,
      sectionCode: e.value
    }))
  }

  function addEditValue(showAddPopup: any) {
    setShowAddPopup(showAddPopup)
  }
  /* Function call on edit */
  const onEdit = (item: any) => {
    setInEditMode({
      rowKey: item.eKey,
      status: true
    })
    setShowEdit(true)
  }
  /* Function call on cancel */
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false
    })
    setShowEdit(false)
  }


  const onDelete = async (item: any) => {
    setClickedItem(item)

    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false
    })
  }

  const onClickAlert = async (button: string, item: any) => {
    if (button === 'OK') {
      setClickedItem(false)
      await deletePointOfContact(item)
      await fetchPointsOfContact()
    } else {
      setClickedItem(false)
    }
  }

  useEffect(() => {
    setMajcomOptions(initialMajcomOptions)
    setSectionOptions(initialSectionOptions)
    setSquadronOptions(initialSquadronOptions)
  }, [initialMajcomOptions, initialSectionOptions, initialSquadronOptions])

  useEffect(() => {
    let majcomValue = ALL_SELECT_OPTION.value
    let majcomLabel = ALL_SELECT_OPTION.label
    let assigneComponentValue = ALL_SELECT_OPTION.value
    let assigneComponentLabel = ALL_SELECT_OPTION.label
    let sectionLabel = ALL_SELECT_OPTION.label
    let sectionValue = ALL_SELECT_OPTION.value
    let squadronValue = ALL_SELECT_VALUE_STRING

    if (initialMajcomOptions.length === 1) {
      majcomValue = initialMajcomOptions[0].value
      majcomLabel = initialMajcomOptions[0].label
    }

    if (assignedComponentOptions.length === 1) {
      assigneComponentValue = assignedComponentOptions[0].value
      assigneComponentLabel = assignedComponentOptions[0].label
    }

    if (initialSectionOptions.length === 1) {
      sectionValue = initialSectionOptions[0].value
      sectionLabel = initialSectionOptions[0].label
    }

    if (initialSquadronOptions.length === 1) {
      squadronValue = initialSquadronOptions[0].value
    }

    setInputValues((prevState) => ({
      ...prevState,
      assignedComponent: assigneComponentLabel,
      assignedComponentCode: assigneComponentValue,
      majcom: majcomLabel,
      majcomCode: majcomValue,
      section: sectionLabel,
      sectionCode: sectionValue,
      squadron: squadronValue
    }))
  }, [assignedComponentOptions, initialSectionOptions, initialMajcomOptions])

  useEffect(() => {
    const filteredPOC = pointsOfContact?.filter(
      (POCEntry) => {
        if (Object.keys(POCEntry).length > 0) {
          return (((inputValues.assignedComponentCode === -1 && 
            assignedComponentOptions.some((e) =>
            e.value === POCEntry.AssignedComponentCode
          )) || POCEntry.AssignedComponentCode ===
          inputValues.assignedComponentCode || (!POCEntry.AssignedComponentCode && 
            inputValues.assignedComponentCode === -1)) &&
            ((inputValues.majcomCode === -1 && 
              majcomOptions.some((e) => e.value === POCEntry.ServicingMAJCOMCode && 
              POCEntry.AssignedComponentCode === e.assignedComponentCode
              )) || POCEntry.ServicingMAJCOMCode === inputValues.majcomCode || 
              (!POCEntry.ServicingMAJCOMCode && inputValues.majcomCode === -1)) &&
            POCEntry?.SectionCodes?.every((section) =>
            initialSectionOptions.some(e => e.value === section)
          )) && ((inputValues.sectionCode === -1 ||
            POCEntry?.SectionCodes?.some((sec) => sec === 
              inputValues.sectionCode)
          )) && ((inputValues.squadron === '' || 
          POCEntry.Squadron === inputValues.squadron)
        )
        } else {
          return
        }
      })?.map((Poc) => {
        return {
          ...Poc,
          AssignedComponent: Poc['AssignedComponent/MetadataValue'],
          AssignedComponentCode: Poc.AssignedComponentCode,
          Section: Poc.Section.length === 0 ? 'All' : Poc.Section.join(', '),
          SectionCodes: Poc.SectionCodes,
          ServicingMAJCOM: Poc['ServicingMAJCOM/MetadataValue'],
          ServicingMAJCOMCode: Poc.ServicingMAJCOMCode,
          Squadron: Poc.Squadron,
          Tags: Poc.Tags,
          Title: Poc.Title,
          eKey: Poc.eKey,
          eTag: Poc.eTag
        }
      })
    setFilteredPointsOfContact(filteredPOC)
  }, [pointsOfContact, inputValues, assignedComponentOptions, initialSectionOptions])



  return (
    <div className='row m-0'>
      {clickedItem && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={(e) => onClickAlert(e, clickedItem)}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='AssignComponent'
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={assignedComponentOptions}
                value={inputValues.assignedComponentCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingMAJCOM'
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMajcomChange}
                options={majcomOptions}
                value={inputValues.majcomCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingOrganization'
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={onSquadronChange}
                options={squadronOptions}
                value={inputValues.squadron}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal  dash poppins-semibold font-11 title-color41 '
                id='Section'
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={sectionOptions}
                value={inputValues.sectionCode}
              />
            </div>
            <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  setShowAddPopup(!showAddPopup)
                }}
              />
            </div>
          </div>
        }
        name='Points of Contact'
      />
      <div className='p-0 settings-main mt-2'>
        {showAddPopup && (
          <AddEditView
            assignedComponentOptions={assignedComponentOptions}
            cancel={() => {
              setShowAddPopup(false)
            }}
            components={components}
            fetchPointsOfContact={fetchPointsOfContact}
            filtersvalue={addEditValue}
            initialMajcomOptions={initialMajcomOptions}
            initialSectionOptions={initialSectionOptions}
            initialSquadronOptions={initialSquadronOptions}
            majcoms={majcoms}
            pointsOfContact={pointsOfContact}
            roleContext={roleContext}
            sections={sections}
            showAddPopup={showAddPopup}
            visibleSquadrons={visibleSquadrons}
          />
        )}
        {filteredPointsOfContact.length > 0 ? 
          filteredPointsOfContact.map((poclist, index) => (
          <div
            className='d-flex flex-column shadow card poppins-medium mb-2 py-3 my-2 mx-3'
            key={addEditValue.name}
          >
            <div className='d-flex px-2'>
              <div className='d-flex flex-column flex-md-row flex-wrap w-100'>
                <div aria-live='polite' className='d-flex flex-column col my-2' tabIndex={0} title={poclist?.PointOfContact?.properties.defaultDisplay}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Name
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist?.PointOfContact?.properties.defaultDisplay}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-100 w-100 max-w-175 my-2' tabIndex={0} title={poclist['AssignedComponent/MetadataValue']
                      ? poclist['AssignedComponent/MetadataValue']
                      : 'All'}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Assigned Component
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist['AssignedComponent/MetadataValue']
                      ? poclist['AssignedComponent/MetadataValue']
                      : 'All'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-100 w-100 max-w-175 my-2' tabIndex={0} title={poclist['ServicingMAJCOM/MetadataValue']
                      ? poclist['ServicingMAJCOM/MetadataValue']
                      : 'All'}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Servicing MAJCOM
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist['ServicingMAJCOM/MetadataValue']
                      ? poclist['ServicingMAJCOM/MetadataValue']
                      : 'All'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-100 w-100 max-w-175 my-2' tabIndex={0} title={poclist.Squadron
                      ? poclist.Squadron
                      : 'All'}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Servicing Organization
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist.Squadron
                      ? poclist.Squadron
                      : 'All'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-100 w-100 max-w-175 my-2' tabIndex={0} title={poclist.SectionCodes.length > 0
                      ? poclist?.Section?.split(',').join(', ')
                      : 'All'}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Section
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist.SectionCodes.length > 0
                      ? poclist?.Section?.split(',').join(', ')
                      : 'All'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-220 min-w-xl-220 max-w-220 my-2' tabIndex={0} title={formatPhoneNumber(poclist.PhoneNumber)}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Phone Number
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {formatPhoneNumber(poclist.PhoneNumber)}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-220 min-w-xl-220 max-w-220 my-2' tabIndex={0} title={poclist.DutyTitle}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Duty Title
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist.DutyTitle}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-100 w-100 max-w-80 my-2' tabIndex={0} title={poclist.IsArchived ? 'Yes' : 'No'}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Is Archived
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {poclist.IsArchived ? 'Yes' : 'No'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
              </div>
              <div className='d-flex align-items-center'>
                <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                  <Buttons
                    aria-label='Edit'
                    className={
                      inEditMode.rowKey === poclist.eKey
                        ? 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold active'
                        : 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    }
                    icon='icon-pencil me-xl-1 font-10'
                    label='Edit'
                    onClick={() => {
                      onEdit(poclist)
                    }}
                  />
                  <Buttons
                    aria-label='Delete'
                    className='btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    icon='icon-trashbin me-xl-1 font-10'
                    label='Delete'
                    onClick={() => onDelete(poclist)}
                  />
                </div>
              </div>
            </div>
            {inEditMode.status && inEditMode.rowKey === poclist.eKey ? (
              <AddEditView
                assignedComponentOptions={assignedComponentOptions}
                cancel={() => onCancel()}
                clickedIndex={index}
                components={components}
                fetchPointsOfContact={fetchPointsOfContact}
                filtersvalue={addEditValue}
                initialMajcomOptions={initialMajcomOptions}
                initialSectionOptions={initialSectionOptions}
                initialSquadronOptions={initialSquadronOptions}
                majcoms={majcoms}
                pointOfContact={poclist}
                pointsOfContact={pointsOfContact}
                roleContext={roleContext}
                sections={sections}
                visibleSquadrons={visibleSquadrons}

              />
            ) : (
              ''
            )}
          </div>
        )) : (
          <div>
          <NO_RESULTS/>
          </div>
        )}
      </div>
    </div>
  )
}
export default SettingsPOC
